/* eslint-disable react-hooks/exhaustive-deps */
import { Checkbox, CircularProgress, Stack, TablePagination, TextField, Typography } from '@mui/material';
import StudiesCrmItem from "./StudiesCrmItem";
import moment from "moment";
import { useState } from 'react';
import { dispatch, useSelector } from 'src/redux/store';
import useTable from 'src/hooks/useTable';
import { deleteManyStudies } from 'src/redux/slices/dashboard/studies';
import { LoadingButton } from '@mui/lab';
import ConfirmAlert from 'src/components/ConfirmAlert';

export default function StudiesTab() {
  const {
    page,
    rowsPerPage,
    selected,
    onSelectRow,
    // onSelectAllRows,
    setSelected,
    onChangePage,
    onChangeRowsPerPage,
  } = useTable();

  const { allStudiesCrm, isLoading, isLoadingDelete } = useSelector((state) => state.studies);
  const [paymentFilter, setPaymentFilter] = useState('all');
  const [open, setOpen] = useState(false); 

  const PAYMENTOPTIONS = [
    { value: 'all', label: 'Todos' },
    { value: 'NONE', label: 'Não criou pagamento' },
    { value: 'PENDING', label: 'Pagamento pendente' },
    { value: 'CANCELED', label: 'Pagamento cancelado' },
    { value: 'CONFIRMED', label: 'Pagamento confirmado' },
  ];

  const filter = (study: any) => {
    if (paymentFilter === 'all') {
      return true;
    } else if (study.paymentStatus === paymentFilter) {
      return true;
    }
  }

  const handleDeleteStudies = () => {
    const infosToDelete = allStudiesCrm.filter((study: any) => selected.indexOf(study.id) !== -1);
    const formattedInfo = infosToDelete.map((info: any) => {
      return {
        id: info.id,
        userid: info.userId
      }
    })

    dispatch(deleteManyStudies(formattedInfo));
    setSelected([]);
  }

  return isLoading ?
    <CircularProgress />
    : <>
      <Stack direction='row' justifyContent='space-between'>
        <Stack direction='row' spacing={4} alignItems='center'>
          <Typography variant='h6'>
            Filtros:
          </Typography>
          <TextField
            select
            label='Status do Pagamento'
            value={paymentFilter}
            onChange={(e) => setPaymentFilter(e.target.value)}
            SelectProps={{ native: true }}
          >
            {PAYMENTOPTIONS.map((opt) =>
              <option key={'PAYOPT_' + opt.value} value={opt.value}>
                {opt.label}
              </option>
            )}
          </TextField>
        </Stack>
        <LoadingButton color='error' variant='contained' disabled={selected.length === 0} onClick={() => setOpen(true)} loading={isLoadingDelete}>
          Excluir {selected.length > 1 ? `${selected.length} estudos` : 'estudo'}
        </LoadingButton>
      </Stack>
      {allStudiesCrm.filter(filter).sort((n1: any, n2: any) =>
        moment(n1.createdAt, "DD/MM/YYYY").isAfter(moment(n2.createdAt, "DD/MM/YYYY")) ? -1 : 1
      ).filter((_data, index) => index >= page * rowsPerPage && index < (page + 1) * rowsPerPage).map((study: any) =>
        <Stack direction='row' spacing={2}>
          <Stack alignItems='flex-start' pt={2}>
            <Checkbox
              onChange={() => onSelectRow(study.id)}
              checked={selected.indexOf(study.id) !== -1}
            />
          </Stack>
          <StudiesCrmItem key={study.id} study={study} />
        </Stack>
      )}
      <TablePagination
        rowsPerPageOptions={[5, 10, 25, 50]}
        component="div"
        count={allStudiesCrm.filter(filter).length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={onChangePage}
        onRowsPerPageChange={onChangeRowsPerPage}
        labelRowsPerPage='Resultados por Página'
        labelDisplayedRows={({ from, to, count }) => {
          return `${from}–${to} de ${count !== -1 ? count : `Mais de ${to}`}`;
        }}
      />
      <ConfirmAlert
        open={open}
        setOpen={setOpen}
        title='Remover Documento'
        subtitle={`Deseja remover permanentemente ${selected.length > 1 ? `${selected.length} estudos` : '1 estudo'}?`}
        callbackConfirm={() => {handleDeleteStudies(); setOpen(false);}}
        callbackDecline={() => { setOpen(false);}}
      />
    </>
}
